<template>
	<div>
		<title-header
			:poll-name="poll.name"
			primary
			title="CÓDIGO ASIGNADO"
			url-image="/static/img/diagnosis/dashboard.svg"
		>
			<v-layout row wrap justify-end align-center>
				<subsidiary-filter
					:subsidiaries="subsidiaries"
					:subsidiary-selected="subsidiarySelected"
					@change-subsidiary="changeSubsidiary"
				></subsidiary-filter>
				<area-filter
					:areas="areas"
					:area-selected="areaSelected"
					@change-area="changeArea"
				></area-filter>
				<download-btn
					alt="Descargar reporte en PDF"
					:height="27"
					url-image="/static/img/icons/pdf.svg"
					@download-item="downloadReport('pdf')"
				></download-btn>
				<download-btn
					alt="Descargar reporte en Excel"
					:height="23"
					url-image="/static/img/icons/excel.webp"
					@download-item="downloadReport('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel')"
				></download-btn>
			</v-layout>
		</title-header>
		<row-graphic
			legend-border-right
			class="row-graphic-height mt-4"
			:row="information"
		/>
		<div 
			v-for="(item, index) in weighing" 
			:key="index"
			class="wrapper-standard mt-4"
			:style="`color:${$appColors.info}`"
		>
			<div class="display-flex align-center justify-space-between mb-4">
				<div
					class="text-blue-big display-flex align-center"
					:style="`color:${$appColors.primary}`"
				>{{item.name}}</div>
				<div
					class="text-gray-bold display-flex align-center"
					:style="`color:${$appColors.info}`"
				>
					<span>PONDERACIÓN TOTAL:</span> 
					<span class="ml-2 big">{{item.percentage}}</span>
				</div>
			</div>
			<v-layout wrap>
				<v-flex 
					v-for="(factor, indexFactor) in item.entities" 
					:key="indexFactor"
					xs3
				>
					<card-total
						:card-reverse="factor.cardReverse"
						:data="factor"
						:poll="poll"
						@reverse-card="reverseCard"
					/>
				</v-flex>
			</v-layout>
		</div>
		<table-graphic
			class="wrapper-climate"
			:climates="climates"
			:info="graphicInfo"
			:poll="poll"
			:style="`color:${$appColors.info}`"
			:weighing="score"
		/>
		<div class="wrapper-close">
			<v-btn 
				class="btn-detail btn-action mr-3" 
				color="primary"
				@click="goToBack">Atrás</v-btn>	
		</div>
	</div>
</template>

<script>
import { equality, find, getPropertysValue } from 'functionallibrary';
import areaFilter from '@/components/diagnosis/area-filter';
import subsidiaryFilter from '@/components/diagnosis/subsidiary-filter';
import cardTotal from '@/components/diagnosis/card-total';
import downloadBtn from '@/components/diagnosis/download-btn';
import helper from '@/shared/helper';
import rowGraphic from '@/components/surveys/action-one/row-graphic';
import tableGraphic from '@/components/diagnosis/table-graphic';
import titleHeader from '@/components/diagnosis/title-header';

const COMUNICATION_CRITERIA = 'Criterio Comunicacion';
const LEADERSHIP_CRITERIA = 'Criterio Liderazgo';

const { generateBlob, showDownloadDialog } = helper;

async function created() {
	({ data: this.subsidiaries } = await this.$httpPraktiko.get('subsidiaries'));
	const newSubsidiary = { code: 'SUB0', id: null, name: 'Todas las Sucursales' };
	this.subsidiaries.unshift(newSubsidiary);
	this.loadData();
}

async function downloadReport(type, contentType) {
	const body = {
		id: this.idsummary,
	};
	if (this.areaId) {
		body.areaId = this.areaId;
	}
	if (this.subsidiaryId) {
		body.subsidiaryId = this.subsidiaryId;
	}
	if (type === 'pdf') {
		body.comments = this.graphicInfo.definition;
	}
	if (type === 'xlsx') {
		body.excel = true;
	}
	try {
		const { data: pdfData } = await this.$httpPraktiko.post(
			`reports/working-environment/${type}`, body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'reporte_clima_laboral', type);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function setInformation(res) {
	// this.information[0].number = res.totalResolved;
	this.information[0].number = res.reportData[0].numApplicants;
	this.information[0].numberTotal = this.areaId || this.subsidiaryId ?
		res.reportData[0].numApplicants : res.numApplicants;
	// this.information[1].number = res.numMale;
	this.information[1].number = res.reportData[0].numMale;
	this.information[1].numberTotal = this.areaId || this.subsidiaryId ?
		res.reportData[0].numApplicants : res.numTotalMale;
	// this.information[2].number = res.numFemale;
	this.information[2].number = res.reportData[0].numFemale;
	this.information[2].numberTotal = this.areaId || this.subsidiaryId ?
		res.reportData[0].numApplicants : res.numTotalFemale;
	this.information[3].number = res.averageAge;
}

function changeArea(areaId) {
	this.areaId = areaId || null;
	this.loadData();
}

function changeSubsidiary(subsidiaryId) {
	this.subsidiaryId = subsidiaryId || null;
	this.loadData();
}

async function loadData() {
	const params = {};
	if (this.areaId) {
		params.areaId = this.areaId;
	}
	if (this.subsidiaryId) {
		params.subsidiaryId = this.subsidiaryId;
	}
	try {
		const { data: response } = await this.$httpPraktiko.get(
			`diagnostic-detail/${this.idsummary}/item`, { params });
		const newReportData = response.reportData.map((rd) => {
			const newRd = { ...rd };
			newRd.entities = rd.entities.map((rde) => {
				const newRde = { ...rde };
				newRde.cardReverse = false;
				return newRde;
			});
			return newRd;
		});
		const newArea = { code: 'GE01', id: null, name: 'Todas las Áreas' };
		response.groups.unshift(newArea);
		this.areas = response.groups.map(ac =>
			({ code: ac.code, id: ac.id, name: ac.name }));
		this.weighing = [...newReportData];
		this.poll = response.poll;
		const pollId = response.pollId;
		this.setInformation(response);
		this.setScore(response);
		this.climates = response.urlImages;
		this.loadGraphicInfo(response.diagnostic.id, pollId, this.areaId);
	} catch (error) {
		this.showGenericError('No hay coincidencias entre la agencia y el área seleccionada. Asegúrate de que ambos datos sean correctos.');
	}
}

function setScore({ reportData }) {
	const getCommunication = find(equality('name', COMUNICATION_CRITERIA));
	this.score.communication = getPropertysValue(
		'percentage',
		getCommunication(reportData) || {},
	);

	const getLeadership = find(equality('name', LEADERSHIP_CRITERIA));
	this.score.leadership = getPropertysValue(
		'percentage',
		getLeadership(reportData) || {},
	);
}

function goToBack() {
	const { toolId } = this.$route.params;
	this.goTo('detail-diagnoses', { params: { toolId, id: this.id } });
}

async function loadGraphicInfo(diagnosticId, pollId, idArea) {
	const params = {};
	if (idArea) {
		params.areaId = idArea;
	}
	if (this.subsidiaryId) {
		params.subsidiaryId = this.subsidiaryId;
	}
	try {
		const { data: response } = await this.$http.get(
			`register/${diagnosticId}/interpretation-diagnostic/${pollId}`, { params });
		this.graphicInfo = response;
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function reverseCard(factorValue) {
	this.$set(factorValue, 'cardReverse', !factorValue.cardReverse);
}

function data() {
	return {
		areaId: null,
		subsidiaryId: null,
		areas: [],
		areaSelected: null,
		subsidiaries: [],
		subsidiarySelected: null,
		cardReverse: false,
		climates: [],
		graphicInfo: {},
		information: [
			{
				image: '/static/img/diagnosis/app.svg',
				number: 0,
				numberTotal: 0,
				description: 'Aplicantes',
			},
			{
				image: '/static/img/diagnosis/male.svg',
				number: 0,
				numTotalMale: 0,
				description: 'Masculino',
			},
			{
				image: '/static/img/diagnosis/female.svg',
				number: 0,
				numTotalFemale: 0,
				description: 'Femenino',
			},
			{
				textBlue: 'PROMEDIO DE EDADES',
				number: 0,
				description: 'años',
			},
		],
		poll: {},
		score: {
			communication: 0,
			leadership: 0,
		},
		weighing: [],
	};
}

export default {
	name: 'weather-summary',
	created,
	components: {
		areaFilter,
		subsidiaryFilter,
		cardTotal,
		downloadBtn,
		rowGraphic,
		tableGraphic,
		titleHeader,
	},
	data,
	methods: {
		downloadReport,
		goToBack,
		loadData,
		loadGraphicInfo,
		reverseCard,
		setInformation,
		setScore,
		changeArea,
		changeSubsidiary,
	},
	props: {
		id: [Number, String],
		idsummary: [Number, String],
	},
};
</script>

<style lang="scss" scoped>
	.text-blue-big {
		font-family: map-get($fonts, bold);
		font-size: 19px;
		text-transform: uppercase;
	}

	.text-gray-bold {
		font-family: map-get($fonts, bold);
		font-size: 15px;

		.big {
			font-size: 31px;
		}
	}

	.display-flex {
		display: flex;
	}

	.wrapper-standard {
		padding-top: 20px; 
	}

	.wrapper-climate {
		margin: 32px 0 100px 0;
		padding-top: 114px;
	}

	.wrapper-close {
		align-items: center;
		background: map-get($colors, white);
		border-top: 1px solid map-get($colors, border-gray);
		bottom: 0;
		display: flex;
		justify-content: center;
		padding: 16px 0 19px 0;
		position: fixed;
		left: 70px;
		right: 0;
		z-index: 2;
	}

	.row-graphic-height {
		height: 51px;
	}
</style>




// WEBPACK FOOTER //
// src/pages/diagnosis/page-weather-summary.vue